export default __webpack_public_path__ + "static/media/Exterior-Paint.a7cef6d2.png";